import { useState, useEffect } from "react";
import "chart.js/auto";
import { Pie } from "react-chartjs-2";
import groupBy from "lodash/groupBy";
import orderBy from "lodash/orderBy";
import { Card, Dropdown, Table } from "react-bootstrap";
import { MoreHorizontal } from "react-feather";
import { Colors, Chart } from "chart.js";
import usePalette from "../../hooks/usePalette";

Chart.register(Colors);

const Znamke = (props: any) => {
  const { ads, ...rest } = props;
  const [sortedAds, setSortedAds] = useState<any>([]);
  const [colors, setColors] = useState<any>([]);
  const [chartData, setChartData] = useState<any>({});
  const palette = usePalette();

  function generateColorPalette(length: number) {
    var palette = [];
    var goldenRatio = 0.618033988749895;

    for (var i = 0; i < length; i++) {
      var hue = (goldenRatio * i) % 1;
      var color = hsvToRgb(hue, 0.5, 0.95);
      palette.push(color);
    }

    return palette;
  }

  function hsvToRgb(h: number, s: number, v: number) {
    var r, g, b;
    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0:
        r = v;
        g = t;
        b = p;
        break;
      case 1:
        r = q;
        g = v;
        b = p;
        break;
      case 2:
        r = p;
        g = v;
        b = t;
        break;
      case 3:
        r = p;
        g = q;
        b = v;
        break;
      case 4:
        r = t;
        g = p;
        b = v;
        break;
      case 5:
        r = v;
        g = p;
        b = q;
        break;
    }

    return (
      "#" +
      toHex((r || 0) * 255) +
      toHex((g || 0) * 255) +
      toHex((b || 0) * 255)
    );
  }

  function toHex(value: number) {
    var hex = Math.round(value).toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  useEffect(() => {
    if (!ads) {
      return;
    }

    const adsByMake = orderBy(groupBy(ads, "make"), "length", "desc");
    setSortedAds(adsByMake);
    const colorsPalette = generateColorPalette(10);
    setColors(colorsPalette);
    setChartData({
      labels: adsByMake.slice(0, 10).map((ads: any) => ads[0].make),
      datasets: [
        {
          data: adsByMake.slice(0, 10).map((ads: any) => ads.length),
          backgroundColor: colorsPalette,
          borderWidth: 5,
          borderColor: palette.white,
        },
      ],
    });
  }, [ads]);

  const options = {
    maintainAspectRatio: true,
    plugins: {
      colorschemes: {
        scheme: "brewer.Paired12",
      },
      legend: {
        display: false,
        labels: {
          color: "rgb(255, 99, 132)",
        },
      },
    },
  };

  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title className="mb-0">Oglasi po znamkah</Card.Title>
      </Card.Header>
      <div className="align-self-center w-100">
        <div className="p-4">
          <div className="chart chart-sm">
            {chartData && chartData.datasets && (
              <Pie data={chartData} options={options} />
            )}
          </div>
        </div>
      </div>
      <Table striped className="my-0">
        <thead>
          <tr>
            <th></th>
            <th>Znamka</th>
            <th className="text-end">Oglasov</th>
            {/*<th className="text-end"></th>*/}
          </tr>
        </thead>
        <tbody>
          {sortedAds.slice(0, 10).map((ads: any, i: number) => {
            return (
              <tr key={i}>
                <td>
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: colors[i],
                    }}
                  >
                    {i + 1}.
                  </span>
                </td>
                <td>{ads[0].make}</td>
                <td className="text-end">{ads.length}</td>
                {/*<td className="text-end text-success">+43%</td>*/}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
};

export default Znamke;
